import { apiAuth as api, apiResponseType } from "./index";

export const getLeftoverProducts = async (filters = {}) => {
  return await api.get("/leftover-products", {
    params: filters,
  });
};

export const createLeftoverProduct =  (data) => {
  return api.postForm("/leftover-products/store", data) as apiResponseType;
};

export const getContestsSelect = async (lotteryId?: number) => {
  const url = lotteryId ? "/contests/select" : "/contests/select";
  const params = lotteryId ? { lottery_id: lotteryId } : {};
  return await api.get(url, { params });
};

export const getContestProductsUnityBalances = async (unity_id, contest_id) => {
  return await api.get(`/contest-products/unity-balances/by-contest-unity`, {
    params: { unity_id, contest_id },
  });
};